/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_EnduranceInputs */

const en_us2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · endurance`)
};

const pt_br2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · resistência`)
};

const es_419_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · resistencia`)
};

const pt_pt2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · resistência`)
};

const fr_fr2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · endurance`)
};

const de_de2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · Ausdauer`)
};

const it_it2_progress_extra_rep_endurance = /** @type {(inputs: Progress_Extra_Rep_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13–20 · resistenza`)
};

/**
* | output |
* | --- |
* | "13–20 · endurance" |
*
* @param {Progress_Extra_Rep_EnduranceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_endurance = /** @type {((inputs?: Progress_Extra_Rep_EnduranceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_EnduranceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_endurance(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_endurance(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_endurance(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_endurance(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_endurance(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_endurance(inputs)
	return en_us2_progress_extra_rep_endurance(inputs)
});
export { progress_extra_rep_endurance as "progress-extra.rep_endurance" }